var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.95431 31.5457 0 20.5 0C9.4543 0 0.5 8.95431 0.5 20C0.5 31.0457 9.4543 40 20.5 40Z",
    fill: "url(#paint0_radial_3870_22364)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.95431 31.5457 0 20.5 0C9.4543 0 0.5 8.95431 0.5 20C0.5 31.0457 9.4543 40 20.5 40Z",
    fill: "url(#paint1_radial_3870_22364)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.95431 31.5457 0 20.5 0C9.4543 0 0.5 8.95431 0.5 20C0.5 31.0457 9.4543 40 20.5 40Z",
    fill: "url(#paint2_radial_3870_22364)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 27.4004C26.3624 27.4004 28.2499 33.2004 26.4499 32.2879C24.0499 31.0754 22.5374 30.9504 20.4999 30.9504C18.4624 30.9504 16.9374 31.0629 14.5499 32.2879C12.7499 33.2004 14.6374 27.4004 20.4999 27.4004Z",
    fill: "#643800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3874 21.1487C28.3874 21.1487 24.7749 21.3362 23.3499 18.9987C23.2624 18.8487 23.1999 18.6862 23.1749 18.5237C23.1249 18.1862 23.3874 17.7987 24.0749 18.0237C28.3249 19.4362 30.4999 18.3987 32.1499 17.6487C32.7874 17.3612 33.4999 17.9737 33.2624 18.4987C32.0874 21.1487 28.3874 21.1487 28.3874 21.1487Z",
    fill: "url(#paint3_radial_3870_22364)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8622 12.5608C32.9247 13.3608 32.0872 13.9233 30.5997 14.0233C29.3372 14.1108 26.5122 13.6108 24.4247 11.2858C24.0372 10.8608 24.5622 10.5733 24.9372 10.8358C26.1872 11.7483 29.4247 12.8108 31.8622 12.3733C32.8372 12.1983 32.8622 12.5608 32.8622 12.5608Z",
    fill: "url(#paint4_linear_3870_22364)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6127 21.1487C12.6127 21.1487 16.2252 21.3362 17.6502 18.9987C17.7377 18.8487 17.8002 18.6862 17.8252 18.5237C17.8752 18.1862 17.6127 17.7987 16.9252 18.0237C12.6752 19.4362 10.5002 18.3987 8.85019 17.6487C8.21269 17.3612 7.50019 17.9737 7.73769 18.4987C8.91269 21.1487 12.6127 21.1487 12.6127 21.1487Z",
    fill: "url(#paint5_radial_3870_22364)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13705 12.5608C8.07455 13.3608 8.91205 13.9233 10.3996 14.0233C11.6621 14.1108 14.4871 13.6108 16.5746 11.2858C16.9621 10.8608 16.4371 10.5733 16.0621 10.8358C14.8121 11.7483 11.5746 12.8108 9.13705 12.3733C8.16205 12.1983 8.13705 12.5608 8.13705 12.5608Z",
    fill: "url(#paint6_linear_3870_22364)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7618 18.1739C17.6368 17.9864 17.3743 17.8739 16.9243 18.0239C12.6743 19.4364 10.4993 18.3989 8.84932 17.6489C8.51182 17.4989 8.14932 17.5989 7.92432 17.8114C10.4118 20.0614 15.7118 20.0989 17.7618 18.1739Z",
    fill: "url(#paint7_linear_3870_22364)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16309 12.6244C1.16309 15.2869 3.31309 17.4369 5.97559 17.4369C8.63809 17.4369 10.7881 15.2869 10.7881 12.6244C10.7881 7.47441 5.97559 2.33691 5.97559 2.33691C5.97559 2.33691 1.16309 7.46192 1.16309 12.6244Z",
    fill: "url(#paint8_linear_3870_22364)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.92559 2.39941C5.50059 5.03692 2.82559 7.51192 3.41309 12.5369C3.85059 16.2494 9.41309 16.4744 10.7756 12.9244C10.6256 15.4369 8.53809 17.4369 5.97559 17.4369C3.31309 17.4369 1.16309 15.2869 1.16309 12.6244C1.16309 7.79942 5.37559 2.99941 5.92559 2.39941Z",
    fill: "url(#paint9_radial_3870_22364)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97558 17.4363C3.31309 17.4363 1.16309 15.2863 1.16309 12.6238C1.16309 7.98633 5.06309 3.36133 5.83808 2.48633C5.00059 5.11133 2.30059 8.78633 2.30059 12.3613C2.30059 15.1863 6.46308 18.6238 10.5131 14.2363C9.85058 16.0988 8.07558 17.4363 5.97558 17.4363Z",
    fill: "url(#paint10_radial_3870_22364)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16309 12.6254C1.16309 15.2879 3.31309 17.4379 5.97559 17.4379C8.63809 17.4379 10.7881 15.2879 10.7881 12.6254C10.7881 7.47539 5.97559 2.33789 5.97559 2.33789C5.97559 2.33789 1.16309 7.46289 1.16309 12.6254Z",
    fill: "url(#paint11_radial_3870_22364)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16309 12.6254C1.16309 15.2879 3.31309 17.4379 5.97559 17.4379C8.63809 17.4379 10.7881 15.2879 10.7881 12.6254C10.7881 7.47539 5.97559 2.33789 5.97559 2.33789C5.97559 2.33789 1.16309 7.46289 1.16309 12.6254Z",
    fill: "url(#paint12_radial_3870_22364)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16309 12.6254C1.16309 15.2879 3.31309 17.4379 5.97559 17.4379C8.63809 17.4379 10.7881 15.2879 10.7881 12.6254C10.7881 7.47539 5.97559 2.33789 5.97559 2.33789C5.97559 2.33789 1.16309 7.46289 1.16309 12.6254Z",
    fill: "url(#paint13_radial_3870_22364)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2378 18.1749C23.3628 17.9874 23.6253 17.8749 24.0753 18.0249C28.3253 19.4374 30.5003 18.3999 32.1503 17.6499C32.4878 17.4999 32.8503 17.5999 33.0753 17.8124C30.5878 20.0624 25.2878 20.0999 23.2378 18.1749Z",
    fill: "url(#paint14_linear_3870_22364)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4998 28.4254C23.9623 28.4254 26.1498 30.3754 27.0997 32.0004C27.1497 30.8254 24.9998 27.4004 20.4998 27.4004C15.9873 27.4004 13.8373 30.8254 13.8998 32.0004C14.8498 30.3879 17.0373 28.4254 20.4998 28.4254Z",
    fill: "url(#paint15_linear_3870_22364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.565 11.8947) scale(24.1274 24.1274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.565 11.8947) scale(18.9821 18.9821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.47366 10.7491) rotate(72.6921) scale(18.0676 9.71787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB672A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3462,
    stopColor: "#DC641B",
    stopOpacity: 0.2846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8036,
    stopColor: "#C25E00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3201 19.4437) rotate(177.118) scale(3.86615 1.71794)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3870_22364",
    x1: 28.9351,
    y1: 15.2469,
    x2: 28.6538,
    y2: 12.5314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6791 19.4437) rotate(2.88189) scale(3.86615 1.71794)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3870_22364",
    x1: 12.0641,
    y1: 15.2472,
    x2: 12.3455,
    y2: 12.5317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3870_22364",
    x1: 12.9327,
    y1: 16.9383,
    x2: 12.6358,
    y2: 20.2352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3870_22364",
    x1: 19.7136,
    y1: 13.9535,
    x2: -7.43689,
    y2: 6.10657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.54653 9.18511) rotate(169.572) scale(7.70806 11.8696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0599486,
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.00627 10.0418) rotate(180) scale(6.23146 10.7511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3432,
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.88159 8.51296) rotate(-103.604) scale(6.99372 3.08136)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.54234 8.72633) rotate(108.995) scale(10.935 8.31027)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5858,
    stopColor: "#0099D6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7213,
    stopColor: "#1477E5",
    stopOpacity: 0.1635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9048,
    stopColor: "#2D4FF8",
    stopOpacity: 0.385
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3640FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3870_22364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.88159 8.51296) rotate(-103.604) scale(8.79202 3.87367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3870_22364",
    x1: 28.0664,
    y1: 16.9393,
    x2: 28.3633,
    y2: 20.2362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3870_22364",
    x1: 20.4995,
    y1: 25.8877,
    x2: 20.4995,
    y2: 30.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEmoji);
export default __webpack_public_path__ + "static/media/delete-emoji.11c0277022d692fe2927d8f353e214fd.svg";
export { ForwardRef as ReactComponent };